import { AccommodationItemsFragment } from '../generated/graphql';

export const getHotelIds = (items?: AccommodationItemsFragment[] | null): string[] => {
  if (!items) {
    return [];
  }

  const hotelIds: string[] = [];
  items.forEach(item => {
    if (item.hotelId) {
      hotelIds.push(item.hotelId);
    }
  });

  return hotelIds;
};
